export default __webpack_public_path__ + "0322fcdf31ad2a09da3f8e16cc3a97ef.ttf";